import { createAction } from "redux-actions";
import { moduleSlug } from "modules/ConfigManager/constants";

export const getConfigByID = createAction(`${moduleSlug}/GET_CONFIG_BY_ID`);
export const getConfigByIDSuccess = createAction(`${moduleSlug}/GET_CONFIG_BY_ID/SUCCESS`);
export const getConfigByIDError = createAction(`${moduleSlug}/GET_CONFIG_BY_ID/ERROR`);

export const cleanupInitialConfig = createAction(`${moduleSlug}/CLEANUP_INITIAL_CONFIG`);

export const setInitialConfig = createAction(`${moduleSlug}/SET_INITIAL_CONFIG`);

export const createConfig = createAction(`${moduleSlug}/CREATE_CONFIG`);
export const createConfigSuccess = createAction(`${moduleSlug}/CREATE_CONFIG/SUCCESS`);
export const createConfigError = createAction(`${moduleSlug}/CREATE_CONFIG/ERROR`);

export const editConfig = createAction(`${moduleSlug}/EDIT_CONFIG`);
export const editConfigSuccess = createAction(`${moduleSlug}/EDIT_CONFIG/SUCCESS`);
export const editConfigError = createAction(`${moduleSlug}/EDIT_CONFIG/ERROR`);

export const setBlockSelectorDialog = createAction(`${moduleSlug}/SET_BLOCK_SELECTOR_DIALOG`);

export const setDataSelectorDialog = createAction(`${moduleSlug}/SET_DATA_SELECTOR_DIALOG`);

export const setDataNormalizersDialog = createAction(`${moduleSlug}/SET_DATA_NORMALIZER_DIALOG`);

export const getNormalizers = createAction(`${moduleSlug}/GET_NORMALIZERS`);
export const getNormalizersSuccess = createAction(`${moduleSlug}/GET_NORMALIZERS/SUCCESS`);
export const getNormalizersError = createAction(`${moduleSlug}/GET_NORMALIZERS/ERROR`);

export const setConfigMessageDialog = createAction(`${moduleSlug}/GET_CONFIG_MANAGER_MESSAGE_DIALOG`);
export const mergeConfigMessageDialog = createAction(`${moduleSlug}/MERGE_CONFIG_MANAGER_MESSAGE_DIALOG`);
